import { useEffect, useState, useContext } from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './Subscription.module.css';
import SubmitButton from '../AuthPages/SubmitButton';
import { Context } from '../../AuthContext';
import { getPlanTier } from '../../config/planLimits';
import UpgradeButton from '../../components/UpgradeButton';

const COMPARISON_ROWS = [
  { label: 'Price', explorer: 'Free', paid: '$15/mo' },
  {
    label: 'Personal Workspaces (Verticals)',
    explorer: '2',
    paid: '5',
  },
  {
    label: 'Replace Personal Workspaces',
    explorer: '1 per month',
    paid: '3 per month',
  },
  {
    label: 'Discovery Refreshes',
    explorer: '2 per month',
    paid: '6 per month',
  },
  {
    label: 'Can Create Research Lab Workspaces',
    explorer: 'No',
    paid: 'Yes',
  },
  {
    label: 'Can Own Research Lab Workspaces',
    explorer: 'No',
    paid: 'Yes',
  },
  {
    label: 'Can Serve as Owner / Advanced Editor / Basic Editor',
    explorer: 'No',
    paid: 'Yes',
  },
  {
    label: 'Can Serve as Read-Only Member',
    explorer: 'Up to 5 verticals',
    paid: 'Unlimited Verticals',
  },
  {
    label: 'Research Lab Plans Available',
    explorer: '-',
    paid: (
      <>
        Core, Growing, & Large Labs (see{' '}
        <a
          className={styles.inlineLink}
          href="https://www.simple-platform.com/pricing"
          target="_blank"
          rel="noopener noreferrer"
        >
          website
        </a>{' '}
        for more details)
      </>
    ),
  },
];

const PlanComparisonTable = ({ currentPlan }) => {
  const explorerActive = currentPlan === 'free' ? styles.activeColumn : '';
  const paidActive = currentPlan === 'paid' ? styles.activeColumn : '';

  return (
    <table className={styles.comparisonTable}>
      <thead>
        <tr>
          <th></th>
          <th className={explorerActive}>
            <div className={styles.headerCell}>
              <img src="/subscriptionIcons/Explorer.svg" alt="TSP Explorer" />
            </div>
          </th>
          <th className={paidActive}>
            <div className={styles.headerCell}>
              <img src="/subscriptionIcons/ExplorerPro.svg" alt="TSP Full Access" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {COMPARISON_ROWS.map((row) => (
          <tr key={row.label}>
            <td>{row.label}</td>
            <td className={explorerActive}>{row.explorer}</td>
            <td className={paidActive}>{row.paid}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const Subscription = () => {
  const [openingPortal, setOpeningPortal] = useState(false);
  const { user } = useContext(Context);
  const { subscriptionStatus } = useOutletContext() || {};
  const currentPlan = getPlanTier(subscriptionStatus);

  useEffect(() => {
    document.title = 'Subscription - The Simple Platform';
  }, []);

  async function manageSubscription() {
    setOpeningPortal(true);
    const token = await user.getIdToken();
    const response = await fetch(process.env.REACT_APP_FLASK_WEBSERVER + 'portal', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    const res = await response.json();
    window.location.href = res.url;
  }

  const planLabel = currentPlan === 'free' ? 'TSP Explorer' : 'TSP Explorer Pro';

  return (
    <div style={{ width: '75vw' }}>
      <h2 className={styles.title}>Subscription</h2>
      <p className={styles.subTitle}>
        Your current TSP account plan: <span style={{ fontWeight: 700 }}>{planLabel}.</span>
      </p>

      {currentPlan === 'free' ? (
        <div className={styles.actionRow}>
          <p className={styles.actionLabel}>Upgrade to a TSP Full Access Account:</p>
          <UpgradeButton
            text="Upgrade Account"
            sx={{
              width: '220px',
              height: '48px',
              fontSize: '16px',
              fontWeight: 700,
              backgroundColor: '#356AC3',
            }}
          />
        </div>
      ) : (
        <div className={styles.actionRow}>
          <p className={styles.actionLabel}>Manage your TSP Subscription:</p>
          <SubmitButton
            text="Manage TSP Subscription"
            width="220px"
            onClick={manageSubscription}
            disabled={openingPortal}
          />
        </div>
      )}

      <PlanComparisonTable currentPlan={currentPlan} />
    </div>
  );
};

export default Subscription;
